import { IoAddOutline, IoDocumentTextOutline } from 'react-icons/io5';

import { CollectionHelpers } from 'src/helpers/CollectionHelpers';

import { Article } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';
import { RouterHelpers } from 'helpers/RouterHelpers';

import { ProfileCard } from 'components/company-profile/components/ProfileCard';
import { SparseSectionPanel, useIsSparseSection } from 'components/company-profile/components/SparseSectionPanel';
import { ProfileSectionHelpers } from 'components/company-profile/helpers/ProfileSectionHelpers';
import { IKImage } from 'components/ik-image/IKImage';
import { RTEContent } from 'components/rte-content/RTEContent';
import { CarouselSection } from 'components/section/CarouselSection';

const CaseStudies = ({ caseStudies, companySlug }: { caseStudies: Article[]; companySlug: string }) => {
    const sparsePanel = useIsSparseSection(caseStudies.length) && (
        <SparseSectionPanel
            key="sparse-panel"
            owner={{
                icon: <IoAddOutline />,
                title: 'Add a case study',
                description: 'Show a real project your products helped deliver.',
                cta: 'Add case study',
                href: RouterHelpers.urls.profiles.edit(companySlug, 'case-studies'),
            }}
            visitor={{
                icon: <IoDocumentTextOutline />,
                title: 'Explore more case studies',
                description: 'See how DC projects are built across the industry.',
                cta: 'Browse case studies',
                href: RouterHelpers.urls.caseStudies(),
            }}
        />
    );

    return (
        <CarouselSection cols={ProfileSectionHelpers.cols}>
            {caseStudies.map((caseStudy) => (
                <ProfileCard
                    key={caseStudy.id}
                    href={CompanyHelpers.urls.article(companySlug, caseStudy.id ?? '')}
                    image={
                        caseStudy.teaser.image && (
                            <IKImage
                                fileOrId={CollectionHelpers.id(caseStudy.teaser.image)!}
                                alt={caseStudy.name}
                                width={600}
                            />
                        )
                    }
                    eyebrow="Case study"
                    eyebrowIcon={<IoDocumentTextOutline />}
                    title={caseStudy.name}
                    description={
                        caseStudy.teaser.description && (
                            <RTEContent content={caseStudy.teaser.description} withCleanText />
                        )
                    }
                    cta="Read case study"
                />
            ))}
            {sparsePanel}
        </CarouselSection>
    );
};

export { CaseStudies };
